<template>
  <div>
    <Head :title="`${form.name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-accent-primary-text" href="/municipalities"
        >Wijken</Link
      >
      <span class="text-accent-primary-text font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="form-label" for="active">Actief</label>
            <input
              type="checkbox"
              id="active"
              v-model="form.active"
              :error="form.errors.active"
              label="Actief"
              :disabled="
                !!municipality.data.users_count || !form.streets.length
              "
            />
          </div>
          <text-input
            v-model="form.zip"
            :error="form.errors.zip"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Postcode"
          />
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Naam"
          />
          <!-- <text-input
            v-model="form.open_street_map_relation_id"
            :error="form.errors.open_street_map_relation_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Open street map relation id"
          /> -->
        </div>

        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <label class="form-label w-full">Straten</label>

          <div
            class="container flex w-full lg:w-1/2 relative"
            v-for="(street, index) in form.streets"
            :key="'street-' + index"
          >
            <text-input v-model="street.name" class="pb-8 pr-6 w-full" />
            <div class="absolute right-8" v-if="!municipality.data.users_count">
              <button
                class="text-red-600 hover:underline mt-2"
                @click.prevent="deleteStreet(index)"
              >
                Verwijderen
              </button>
            </div>
          </div>

          <div class="container flex w-full relative justify-end pb-8 pr-6">
            <button
              class="btn-indigo"
              tabindex="-1"
              type="button"
              @click="addStreet"
            >
              Straat toevoegen
            </button>
          </div>
        </div>

        <div
          class="
            flex
            items-center
            px-8
            py-4
            bg-gray-50
            border-t border-gray-100
          "
        >
          <button
            v-if="!municipality.data.users_count"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy"
          >
            Wijk verwijderen
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit"
            >Wijk aanpassen</loading-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Layout from "@/Shared/Layout";
import TextInput from "@/Shared/TextInput";
import SelectInput from "@/Shared/SelectInput";
import LoadingButton from "@/Shared/LoadingButton";
import TrashedMessage from "@/Shared/TrashedMessage";

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    municipality: Object,
  },
  remember: "form",
  data() {
    return {
      form: this.$inertia.form({
        active: this.municipality.data.active,
        zip: this.municipality.data.zip,
        name: this.municipality.data.name,
        // open_street_map_relation_id:
        //   this.municipality.data.open_street_map_relation_id,
        streets: this.municipality.data.streets?.data || [],
      }),
    };
  },
  methods: {
    update() {
      this.form.put(`/municipalities/${this.municipality.data.id}`);
    },
    destroy() {
      if (confirm("Weet je zeker dat je deze wijk wil verwijderen?")) {
        this.$inertia.delete(`/municipalities/${this.municipality.data.id}`);
      }
    },

    addStreet() {
      this.form.streets.push({
        name: "",
        id: null,
      });
    },

    deleteStreet(index) {
      this.form.streets.splice(index, 1);
    },
  },
};
</script>
